module.exports = __webpack_public_path__ + "img/Feedback@2x.8a34bc02.png";